import React from "react";

/**
 * Table of employees with their OT hours (used for both Top and Lowest lists).
 *
 * @param {string} title
 * @param {{name: string, serviceNumber: string, otHours: number}[]} employees
 * @param {boolean} [showViewAll]
 * @param {() => void} [onViewAll]
 */
export default function EmployeeTable({ title, employees, showViewAll = false, onViewAll }) {
  return (
    <div className="bg-white rounded-xl border border-surface-200 p-5 shadow-sm flex flex-col transition-all duration-200 hover:shadow-md">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-base font-semibold text-surface-800">{title}</h2>
        {showViewAll && (
          <button
            onClick={onViewAll}
            className="text-sm font-medium text-primary-600 hover:text-primary-700 hover:underline transition-colors"
          >
            View All
          </button>
        )}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="border-b border-surface-100">
              <th className="py-2.5 px-2 text-[10px] font-bold text-surface-400 uppercase tracking-widest">
                Employee Name
              </th>
              <th className="py-2.5 px-2 text-[10px] font-bold text-surface-400 uppercase tracking-widest">
                Service No.
              </th>
              <th className="py-2.5 px-2 text-[10px] font-bold text-surface-400 uppercase tracking-widest text-right">
                OT Hours
              </th>
            </tr>
          </thead>
          <tbody>
            {employees.map((emp, i) => (
              <tr
                key={emp.serviceNumber}
                className={`hover:bg-primary-50 transition-colors duration-150 h-12 ${
                  i < employees.length - 1 ? "border-b border-surface-100" : ""
                }`}
              >
                <td className="py-2 px-2 text-sm text-surface-700 font-medium">{emp.name}</td>
                <td className="py-2 px-2 text-sm text-surface-500">{emp.serviceNumber}</td>
                <td className="py-2 px-2 text-sm text-surface-700 font-semibold text-right">
                  {emp.otHours.toFixed(1)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}